export default __webpack_public_path__ + "static/media/nombaLogo.fd6da944.png";